module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAsCAYAAAAjFjtnAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAFQSURBVGiB7ZhhbYNAHEd/kAlAAnVQCUiYg9VBK4Ep6KqgErYpQMLmAAng4O0DbGHkepAC/UNyL+mHC4F7jx6QnLQAQAq8AxVQAvkS8ywCkLTifc7WbqMAjg75XxJrPy/t0vnyBJxXGdGKXz3iXUrgYO0s6U88HynuCsks5U+thIsrUNA8zFVn7KJ4aAhwGBBPPec+e85dNmRAvPCJ33Gt/ZzimWey8t67RvO9yHF/M2Dg3xwzQcrtdVsy05tkIKRqj41/9eJ/Jc4mPnuIlfjUkIhmnR0lnW5c81vSp6Ryef1/7NR4ue56Lek1iqK3CCgkZY80m5GPCMDaYgpPvXHd/tZMou6y6j0kmZnWSICXrnBsLTSVEGBNCLAmBFgTAqwJAdaEAGtCgDUhwJoQYE0IsGbzAf19of0G9rl23cHmd+ZirX8nzkcdS7pomxG1pMsP+X8SewYL4loAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xxgg.png
// module id = A3e7
// module chunks = 265